import styled, { css, RuleSet } from 'styled-components';

const Text = styled.div<{
  $desktopStyles?: RuleSet<object>;
  $mobileStyles?: RuleSet<object>;
}>(
  ({ theme, $desktopStyles, $mobileStyles }) => css`
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.larger};
    ${$mobileStyles}

    @media (min-width: ${theme.sz.md}) {
      font-size: ${theme.DEPRECATED_ty.large};
      line-height: 130%;
      /* or 26px */
      ${$desktopStyles}
    }
  `,
);

export default Text;
